import {Component, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {Router} from '@angular/router';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {PlaygroundService} from '../../service/playground.service';
import {PlaygroundSalesOrder} from '../../model/playground.model';

@Component({
  selector: 'playground-list',
  templateUrl: './playground-list.component.html',
  standalone: false
})
export class PlaygroundListComponent implements OnInit, AfterViewInit {
  dataSource = new MatTableDataSource<PlaygroundSalesOrder>();
  displayedColumns = ['id', 'tripId', 'tripReference', 'mainClientName', 'tripStartDate', 'isCancelled', 'dateCreated', 'actions'];
  nextTripId = 900001;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private playgroundService: PlaygroundService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadOrders();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  loadOrders(): void {
    this.playgroundService.getSalesOrders().subscribe(orders => {
      this.dataSource.data = orders;
      if (orders.length > 0) {
        const maxTripId = Math.max(...orders.map(o => o.tripId));
        this.nextTripId = maxTripId + 1;
      }
    });
  }

  createNew(): void {
    this.playgroundService.createSalesOrder({
      tripId: this.nextTripId,
      tripReference: `TEST-${this.nextTripId}`,
      bookedDate: new Date().toISOString(),
      isCancelled: false
    }).subscribe(created => {
      this.router.navigate(['/Playground', created.id]);
    });
  }

  openOrder(id: number): void {
    this.router.navigate(['/Playground', id]);
  }

  deleteOrder(id: number, event: Event): void {
    event.stopPropagation();
    if (confirm('Delete this test sales order?')) {
      this.playgroundService.deleteSalesOrder(id).subscribe(() => this.loadOrders());
    }
  }
}
